import axios from 'axios';
import { BASE_URL } from '../config';

// ----------------------------------------------------------------------
// const BASE_URL1 = 'http://localhost:5055/';
const axiosInstance = axios.create({
  baseURL: BASE_URL
});
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        // localStorage.clear();
        window?.location?.refresh();
        // serviceWorkerRegistration.unregister();
      }
      return Promise.reject((error.response && error.response.data) || 'Something went wrong');
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
